import { useCallback } from 'react';
import { API_URL, useAuth } from '../../context/AuthContext';
import { warehouseWrites } from '../../updates/activity';
export class DriverRequestError extends Error {
  constructor(message: string, public status: number) { super(message); }
}
export function useDriverApi() {
  const { currentShop, refresh } = useAuth();
  const domain = currentShop?.domain; const organizationId = currentShop?.organizationId;
  return useCallback(async <T,>(path: string, body?: unknown, signal?: AbortSignal): Promise<T> => {
    if (!domain) throw new DriverRequestError('Choose a warehouse account first', 400);
    const headers = new Headers({ 'Content-Type': 'application/json', 'X-Shop-Domain': domain });
    if (organizationId) headers.set('X-Organization-Id', organizationId);
    const request = () => fetch(`${API_URL}/api/driver${path}`, { method: body === undefined ? 'GET' : 'POST', headers, credentials: 'include', cache: 'no-store', signal,
      ...(body === undefined ? {} : { body: JSON.stringify(body) }) });
    const endWrite = body === undefined ? () => {} : warehouseWrites.begin();
    try {
      let response = await request();
      if (response.status === 401 && await refresh()) response = await request();
      const data = await response.json();
      if (!response.ok || data.success === false) throw new DriverRequestError(data.error || 'Unable to load or save this delivery', response.status);
      return data as T;
    } finally { endWrite(); }
  }, [domain, organizationId, refresh]);
}
export const driverError = (error: unknown) => error instanceof Error ? error.message : 'Unable to load or save this delivery';
